/** 字典数据API */
import { cachePromise, getCachePromise } from '@/utils/common';
import type { Api } from '@/typings/api';
import type { DictTypeEnum } from '@/enum';
import { get, post } from '../../request';
const prefix = '/common/dictData';
/**
 * 根据类型查询字典数据
 *
 * @param dictType 字典类型
 */
export function findByType(dictType: DictTypeEnum) {
  return get<Api.Base.DictData[]>(`${prefix}/findByType`, { dictType });
}
export async function findDictDataByType(dictType: DictTypeEnum): Promise<Api.Base.DictData[] | null> {
  // const dictData = localStg.get(dictType);
  // if (dictData && dictData.length > 0) {
  //   return dictData;
  // }
  let promise = getCachePromise(dictType);
  if (!promise) {
    // console.log('🚀 ~ initDictData ~ options:');
    promise = findByType(dictType);
    cachePromise(dictType, promise);
  }
  const { data } = await promise;
  if (data && data.length > 0) {
    const optionData = data.filter((item: Api.Base.DictData) => item.enable);
    // localStg.set(dictType, optionData, 60 * 1000);
    return optionData;
  }
  return null;
}
/**
 * 分页查询
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Base.DictData> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询全部
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Base.DictData> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个字典数据
 *
 * @param id 字典数据ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Base.DictData> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存字典数据
 *
 * @param params 字典数据信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新字典数据信息
 *
 * @param params 字典数据信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除字典数据
 *
 * @param id 字典数据ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除字典数据
 *
 * @param ids 字典数据ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
